import InitiativePlanningSummary from "./initiativePlanningSummary";

const planningSummarySimplified = (initiative) => {
    const detailedPlanningStatus = InitiativePlanningSummary(initiative).planningStatus;

    if (detailedPlanningStatus.startsWith('Past due')) {
        return 'Past due';
    } else if (detailedPlanningStatus.startsWith('Due soon')) {
        return 'Due soon';
    } else if (detailedPlanningStatus.startsWith('Not planned')) {
        return 'Not planned';
    } else if (detailedPlanningStatus.startsWith('On plan')) {
        return 'On plan';
    } else if (detailedPlanningStatus.startsWith('Realized')) {
        return 'Realized';
    } else if (detailedPlanningStatus.startsWith('Completed on time or early')) {
        return 'Completed on time or early';
    } else if (detailedPlanningStatus === 'Cancelled') {
        return 'Cancelled';
    }
    return detailedPlanningStatus;
};

export default planningSummarySimplified;